import React, { useState } from 'react'
import { Link } from 'react-router-dom'

function Signup() {
   const [formData,setData] =  useState({
    name:"",email:"",password:"",cpassword:""
   });

   const handleInput = (e)=>{
    const {name,value} = e.target;
    setData({
        ...formData,
        [name]:value
    })
   }

   const handleSubmit = (e)=>{
    e.preventDefault();
    const {name,email,password,cpassword} = formData;
    if(name && email && password){
        if(password === cpassword){
            alert("Name: "+name+" Email: "+email+" Password: "+password);
        }else{
            alert("Password not match");
        }
    }else{
        alert("Please fill all fields")
    }
   }
  return (
    <>
        <section id='auth' className="text-center py-4">
        <img src="img/auth.png" alt="logo" width="200rem" />
        <hr />
        <form className='box' method="post" onSubmit={handleSubmit}>
            <div className="mb-3">
                <label htmlFor="name" className="form-label"><strong>What should we call you?</strong></label>
                <input type="text" className="form-control" value={formData.name} onChange={handleInput} name="name" id="name" placeholder="Enter Profile Name"/>
            </div>
            <div className="mb-3">
                <label htmlFor="email" className="form-label"><strong>What's your email?</strong></label>
                <input type="email" className="form-control" value={formData.email} onChange={handleInput} name="email" id="email" placeholder="Enter Email"/>
            </div>
            <div className="mb-3">
                <label htmlFor="password" className="form-label"><strong>Create a password</strong></label>
                <input type="password" className="form-control" value={formData.password} onChange={handleInput} name="password" id="password" placeholder="Enter Password"/>
            </div>
            <div className="mb-3">
                <label htmlFor="cpassword" className="form-label"><strong>Confirm password</strong></label>
                <input type="password" className="form-control" value={formData.cpassword} onChange={handleInput} name="cpassword" id="cpassword" placeholder="Confirm Password"/>
            </div>
            <div className="mb-3 text-center">
                <button type='submit'>Signup</button>
            </div>
            <div className="mb-3 text-center">
                <p>Already Have Account? <Link to="/login">Login</Link></p>
            </div>
        </form>
        </section>
    </>
  )
}

export default Signup